exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cities-page {\n  width: 100%;\n  flex-grow: 1;\n  display: flex;\n}\n.cities-page__content {\n  display: flex;\n  padding: 32px;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n.cities-page__panel {\n  margin: 32px;\n  font-size: 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/scenes/Cities/containers/cities.less
// module id = 1109
// module chunks = 0